import { Loader, ModalPanel } from "dash-styled"
import { FC } from "react"

export const LoaderModal: FC<{ onClose: () => void }> = ({ onClose }) => (
    <ModalPanel
        testId="loading-dialog"
        onClose={onClose}
        className="max-w-2xl w-full"
    >
        <Loader />
    </ModalPanel>
)
